export const linkStyles = {
  components: {
    Link: {
      baseStyle: {
        textDecoration: "underline",
        color: "text.1",
        fontWeight: "semibold",
        lineHeight: "1.4375rem",
        boxShadow: "none",
        // _focus: {
        //   boxShadow: "none",
        // },
        // _active: {
        //   boxShadow: "none",
        // },
        // _hover: {
        //   border: "none",
        // },
      },
      _hover: {
        // textDecoration: "none",
        // border: "none",
      },
    },
  },
};
